import Button from "src/Components/Button/Button";
import Info from "src/images/info.png";
import GridViewWithHeaderNode from "src/SharedComponents/GridViewWithHeader/GridViewWithHeaderNode";
import Text from "src/SharedComponents/Text/Text";
import { useEffect, useMemo, useState } from "react";
import AddCoupon from "../AddCoupon/AddCoupon";
import { IPaymentProducts, ISuiteProductComboInfos } from "src/Utils/Hooks/Payments/useGetPaymentProducts";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useTranslation } from "react-i18next";
import { getCurrencySymbol } from "src/Utils/CurrencySymbol/CurrencySymbol";
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
export interface ICurrentSubscriptionProps {
    purchaseDate: string;
    clinicId: string;
    products?: IPaymentProducts;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    isClinicAdmin: boolean;
}
const CurrentSubscription: React.FC<ICurrentSubscriptionProps> = ({ purchaseDate, clinicId, products, setInfo, isClinicAdmin }) => {
    const [showAddCoupon, setShowAddCoupon] = useState(false);
    const { t } = useTranslation();
    const month = t('Month');
    const annual = t('Annual');
    const [interval, setInterval] = useState<string>('');
    const [currentPrice, setCurrestPrice] = useState<number>();
    const [currentPackage, setCurrentPackage] = useState<ISuiteProductComboInfos | undefined>();
    const remainingCredit = useMemo(() => {
        if (!products?.credit) {
            return 0;
        }
        return Math.abs(products?.credit) / 100;
    }, [products?.credit]);

    useEffect(() => {
        var packageInfo = products?.suiteProductComboInfos?.find(
            (suite) =>
                suite?.monthlyInfo?.priceId === products?.currentPriceId ||
                suite?.yearlyInfo?.priceId === products?.currentPriceId
        );
        if (packageInfo?.monthlyInfo?.priceId === products?.currentPriceId) {
            setInterval(month);
            setCurrestPrice(packageInfo?.monthlyInfo?.price);
        } else if (packageInfo?.yearlyInfo?.priceId === products?.currentPriceId) {
            setInterval(annual);
            setCurrestPrice(packageInfo?.yearlyInfo?.price);
        }
        setCurrentPackage(packageInfo);
    }, [products, currentPackage, products?.currentPriceId, annual, month]);

    return (
        <div>
            {showAddCoupon && 
                <AddCoupon
                    onClose={() => setShowAddCoupon(false)}
                    clinicId={clinicId}
                    setInfo={setInfo} />
            }
            {currentPackage &&
            <GridViewWithHeaderNode title={t('YourSubscription')}>
                <div className="d-flex" style={{ width: '98%' }}>
                    <div style={{ width: '33%' }}>
                        <Text text={t('SignUpDate')} />
                        <div>
                            <span className='text-left'
                                style={{ fontSize: '20px', fontWeight: '600' }}>
                                {formatDateString(purchaseDate)}
                            </span>
                        </div>
                    </div>
                    <div style={{ width: '33%' }}>
                        <Text text={t('PaymentTerms')} />
                        <div>
                            <span className='text-left'
                                style={{ fontSize: '20px', fontWeight: '600' }}>
                                {currentPrice} {currentPackage?.currency && getCurrencySymbol(currentPackage?.currency)}
                            </span>
                            <span> /{t(interval)}</span>
                        </div>
                    </div>
                    <div style={{ width: '33%' }}>
                         {remainingCredit > 0 &&<>
                        <Text text="Credit" />
                        <div className="d-flex align-items-center" style={{ flex: 2 }}>
                           
                            <>
                                <div>
                                    <span className='text-left'
                                        style={{ fontSize: '25px', fontWeight: 'bold' }}>
                                        {remainingCredit} {currentPackage?.currency && getCurrencySymbol(currentPackage?.currency)}
                                    </span>
                                    <span> /{t('Remaining')}</span>
                                </div>
                            
                            &nbsp;
                            <div data-tooltip="Credit will be used for upcoming payments." data-flow="bottom" style={{ width: '40px', height: '40px', borderRadius: '100%', marginBottom: '3px' }} className="d-flex justify-content-center align-items-center infoHover">
                                <span>
                                    <img src={Info} alt="Info" />
                                </span>
                            </div>
                            </>

                        </div>
                        </>}

                    </div>

                    <div className='col-4' >
                        <div className="d-flex justify-content-end">
                            <Button
                                text={t('AddCoupon')}
                                onClick={() => { setShowAddCoupon(true) }}
                                disable={!isClinicAdmin}
                            />
                        </div>
                    </div>

                </div>
            </GridViewWithHeaderNode>
       }
        </div>
    );
}
export default CurrentSubscription;